const s = require("./sheetDataPart.module.scss");

import { default as React, useState, useRef, useContext } from "react";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const SheetDataPart = (props: any) => {

    const [scrollPosition, setScrollPosition] = useState({ top: 0, left: 0 });
    const onScroll = (e: React.UIEvent<HTMLDivElement, UIEvent>) => {
        setScrollPosition({ top: e.currentTarget.scrollTop, left: e.currentTarget.scrollLeft });
    };

    const noDataMessage = props.noDataMessage ?? "No data available";
    const dataRows = props.dataRows != null ? props.dataRows : !props.data ? -1 : props.data.length;

    return <div className="xx" style={{ flex: "1", position: "relative", overflow: "auto" }} onScroll={onScroll}>
        <div className="shadow-sm bg-white rounded" style={{ display: "inline-block", margin: "1rem" }}>
            {React.cloneElement(props.children, { scrollPosition: scrollPosition })}
            {props.isLoading && <div className={s.loading} style={{ top: scrollPosition.top + "px", left: scrollPosition.left + "px" }}></div>}
            {!props.isLoading && props.error === "" && dataRows === 0 && <div className={s.nodata} style={{ left: scrollPosition.left + "px" }}>{noDataMessage}</div>}
            {!props.isLoading && props.error !== "" && <div className={s.error} style={{ left: scrollPosition.left + "px" }}><FontAwesomeIcon icon={faExclamationTriangle} /> {props.error} {props.message}</div>}
            {!props.isLoading && props.error === "" && dataRows === -1 && <div className={s.error} style={{ left: scrollPosition.left + "px" }}><FontAwesomeIcon icon={faExclamationTriangle} /> {"Wrong data packet received"}</div>}
        </div>
    </div>;
};
export default SheetDataPart;